<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <p class="buttons">
          <app-button-delete @click="deleteItem" v-if="!newItem" />
        </p>
        <app-content-title v-if="!newItem" :title="item.name" />
        <app-content-title v-if="newItem" :title="translations.newEpgSource" />
      </div>
      <app-tabs
          full-width
          :shouldLoadFirstTab="newItem"
          :loadTab="params.tab"
          @appTabChanged="onAppTabChanged"
      >
        <div :title="translations.epgSource">
          <app-settings @submit="submitForm" :disabled="pending">
            <app-settings-content>
              <app-settings-desc :title="translations.basicInfo">
                <p>
                  <translate>Založeno</translate>:
                  <br />
                  <span v-html="formatDateAdvanced(item._created)" />
                </p>
                <p>
                  <translate>Poslední změna</translate>:
                  <br />
                  <span v-html="formatDateAdvanced(item._updated)" />
                </p>
              </app-settings-desc>
              <app-settings-options>
                <app-settings-col class="field_left">
                  <app-input
                      required
                      :label="translations.name"
                      :error="errors.items.find(el => el.field === 'name')"
                      name="name"
                      v-model="formItem.name"
                  />
                </app-settings-col>

                <app-settings-col class="field_right">
                  <app-settings-select
                      required
                      :error="errors.items.find(el => el.field === 'parser')"
                      :label="translations.parser"
                  >
                    <app-select
                        :options="enums.epgSourceParser"
                        v-model="formItem.parser"
                        name="parser"
                    />
                  </app-settings-select>
                </app-settings-col>

                <app-settings-col class="field_left">
                  <app-settings-select
                      required
                      :error="errors.items.find(el => el.field === 'triggerInterval')"
                      :label="translations.triggerInterval"
                  >
                    <app-select
                        :options="enums.epgSourceTriggerInterval"
                        v-model="formItem.triggerInterval"
                        name="triggerInterval"
                    />
                  </app-settings-select>
                </app-settings-col>

                <app-settings-col class="field_right">
                  <app-settings-control class="checkbox">
                    <app-checkbox
                        name="enabled"
                        :title="translations.enabled"
                        :error="!!errors.first('enabled')"
                        v-model="formItem.enabled"
                    />
                  </app-settings-control>
                </app-settings-col>

                <app-settings-col class="field_left">
                  <app-settings-control class="checkbox">
                      <app-checkbox
                          name="saveDownloadedData"
                          :title="translations.saveDownloadedData"
                          :error="!!errors.first('saveDownloadedData')"
                          v-model="formItem.saveDownloadedData"
                          @change="changeDownloadedData"
                      />
                  </app-settings-control>
                </app-settings-col>
                <app-settings-col class="field_right">
                  <app-input
                      :disabled="!saveDownloadedData"
                      :label="translations.filename"
                      :error="errors.items.find(el => el.field === 'filename')"
                      name="filename"
                      v-model="formItem.filename"
                  />
                </app-settings-col>



                <app-settings-input
                    required
                    :error="errors.items.find(el => el.field === 'url')"
                    :label="translations.url"
                >
                  <app-textarea
                    name="url"
                    v-model="formItem.url"
                  />
                </app-settings-input>

                <app-settings-col class="field_left">
                  <app-settings-control class="checkbox">
                    <app-checkbox
                        name="ftpAccess"
                        :title="translations.ftpAccess"
                        :error="!!errors.first('ftpAccess')"
                        v-model="formItem.ftpAccess"
                        @change="changeFtpAccess"
                    />
                  </app-settings-control>
                </app-settings-col>
                <div v-if="ftpAccess">
                  <app-settings-col class="field_left">
                    <app-input
                        :label="translations.ftpUrl"
                        :error="errors.items.find(el => el.field === 'ftpUrl')"
                        name="ftpUrl"
                        v-model="formItem.ftpUrl"
                    />
                  </app-settings-col>
                  <app-settings-col class="field_right">
                    <app-input
                        :label="translations.ftpUsername"
                        :error="errors.items.find(el => el.field === 'ftpUsername')"
                        name="ftpUsername"
                        v-model="formItem.ftpUsername"
                    />
                  </app-settings-col>
                  <app-settings-col class="field_left">
                    <app-input
                        :label="translations.ftpPassword"
                        :error="errors.items.find(el => el.field === 'ftpPassword')"
                        name="ftpPassword"
                        type="password"
                        browser-autocomplete="new-password"
                        v-model="formItem.ftpPassword"
                    />
                  </app-settings-col>
                  <app-settings-col class="field_right">
                    <app-input
                        :label="translations.ftpImportDirectoryPath"
                        :error="errors.items.find(el => el.field === 'ftpImportDirectoryPath')"
                        name="ftpImportDirectoryPath"
                        v-model="formItem.ftpImportDirectoryPath"
                    />
                  </app-settings-col>
                </div>
              </app-settings-options>

            </app-settings-content>

            <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'epg-sources' }">
              <app-content-save-button :disabled="pending" @click="disallowBack" />
            </app-settings-buttons>
          </app-settings>
        </div>
        <div
          :title="translations.tvStation"
          :data-disabled-title="translations.tvStationSaveFirst"
          :data-disabled="!item || !item._id"
        >
        <TvStationEpgJsonDetail :title=this.item.name />
        </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import TvStationEpgJsonDetail from 'views/EpgSource/TvStationEpgJsonDetail'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'EpgSource',
  enums: true
})

export default {
  name: 'epg-source',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  components: { TvStationEpgJsonDetail },
  data() {
    return {
      ftpAccess: false,
      saveDownloadedData: false,
    }
  },
  computed: {
    translations() {
      return {
        newEpgSource: this.$gettext('Nový zdroj EPG'),
        epgSource: this.$gettext('Epg zdroj'),
        basicInfo: this.$gettext('Základní údaje'),
        name: this.$gettext('Název'),
        parser: this.$gettext('Parser'),
        triggerInterval: this.$gettext('Interval spuštění'),
        enabled: this.$gettext('Povoleno'),
        ftpAccess: this.$gettext('FTP přístup'),
        ftpUrl: this.$gettext('FTP url'),
        ftpUsername: this.$gettext('FTP uživatel'),
        ftpPassword: this.$gettext('FTP heslo'),
        ftpImportDirectoryPath: this.$gettext('FTP importní složka'),
        url: this.$gettext('URL'),
        list: this.$gettext('Seznam'),
        tvStation: this.$gettext('TV stanice'),
        tvStationSaveFirst: this.$gettext('Tv stanice (nutné uložit skupinu stanic)'),
        saveDownloadedData: this.$gettext('Ukládat stažená data'),
        filename: this.$gettext('Název souboru')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Zdroje EPG'), link: { name: 'epg-sources' } },
        this.item.name || this.$gettext('Nový zdroj EPG')
      ]
    }
  },
  methods: {
    changeFtpAccess(value) {
      this.ftpAccess = value
    },
    changeDownloadedData(value) {
      this.saveDownloadedData = value;
    }
  },
  watch: {
    formItem() {
      this.ftpAccess = this.formItem.ftpAccess;
      this.saveDownloadedData = this.formItem.saveDownloadedData;
    }
  }
}
</script>
